<template>
  <div class="search-wrapper" v-bind:class="{ active: searchOpen }">
    <v-layout align-center style="background-color: #1e3c72 !important;" class="input-holder" :style="select.value === 'expenses_id' ? 'width:70%' : 'width:86%'" justify-center>
      <v-menu offset-y>
        <template v-slot:activator="{ attrs, on }">
          <v-btn class="ma-4" v-bind="attrs" v-on="on" icon large>
            <v-icon class="mx-0 my-0" left size="30" style="color: azure;">search</v-icon>
            <v-icon class="mx-0 my-0" right size="20" style="color: azure;">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-tile
            v-for="(item, index) in items"
            :key="index + 'A'"
            link
            active-class="red--text"
            :class="select.value === item.value ? 'primary--text' : ''"
            @click="changeOption(item)"
          >
            <v-list-tile-title v-text="item.name"></v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-text-field
        solo
        hide-details
        clearable
        v-model="id"
        :placeholder="$t('general.generalSearch') + select.name"
        @keypress.enter="search()">
      </v-text-field>
    </v-layout>
  </div>
</template>

<script>
export default {
  data () {
    return {
      id: '',
      default: '',
      searchOpen: true,
      select: { name: this.$t('generalSearch.check'), value: 'expenses_id' }
    }
  },
  computed: {
    items () {
      return [
        { name: this.$t('generalSearch.check'), value: 'expenses_id' },
        { name: this.$t('generalSearch.uuidNumber'), value: 'uuid' }
      ]
    }
  },
  methods: {
    changeOption (val) {
      this.id = ''
      this.select = val
    },
    search () {
      if (this.$route.path !== '/search') {
        this.$router.push({ name: 'generalSearchPage' })
        this.$store.state.search = this.id
        this.$store.state.type = this.select.value
      } else {
        this.$store.state.search = this.id
        this.$store.state.type = this.select.value
      }
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/Layout/Components/Header/SearchBox.vue